export default __webpack_public_path__ + "ad15ecab12e1cd3e268456133a533860.ttf";